import {GET_GROUP_DETAIL_NEWS_START} from "../../types";

export const group_detail = (payload) => ({
    type: GET_GROUP_DETAIL_NEWS_START,
    payload,
});
